import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { FormControlOption } from '../../definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
  selector: 'risk-profil-fifth-part-form',
  templateUrl: './risk-profil-fifth-part-form.component.html',
  styleUrls: ['./risk-profil-fifth-part-form.component.scss'],
  standalone: false,
})
export class RiskProfilFifthPartFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  options1: FormControlOption[] = [
    {
      value: 'LOW_YIELD_NO_RISK',
      label: 'Un potentiel de rendement faible sans risque de perte en capital',
      suffix: { title: 'A' },
    },
    {
      value: 'LOW_YIELD_LOW_RISK',
      label:
        'Un potentiel de rendement faible avec peu de risque de perte en capital',
      suffix: { title: 'B' },
    },
    {
      value: 'MEDIUM_YIELD_RISK',
      label:
        'Un potentiel de rendement moyen avec un risque de perte en capital',
      suffix: { title: 'C' },
    },
    {
      value: 'HIGH_YIELD_HIGH_RISK',
      label:
        'Un potentiel de rendement élevé avec un risque élevé de perte en capital',
      suffix: { title: 'D' },
    },
  ];
  options2: FormControlOption[] = [
    {
      value: 'PROPORTIONAL',
      label:
        'Si vous voulez augmenter votre rendement potentiel, vous devez accepter le risque de perte en capital',
      suffix: { title: 'A' },
    },
    {
      value: 'INVERSELY_PROPORTIONAL',
      label:
        'Si vous augmentez le risque, vous diminuez votre rendement potentiel',
      suffix: { title: 'B' },
    },
    { value: 'UNKNOWN', label: 'Je ne sais pas ', suffix: { title: 'C' } },
  ];
  options3: FormControlOption[] = [
    {
      value: 'NOW',
      label: '1000€ tout de suite',
      suffix: { title: 'A' },
    },
    {
      value: 'LATER',
      label: '1200€ dans un an',
      suffix: { title: 'B' },
    },
  ];
  options4: FormControlOption[] = [
    {
      value: 'NONE',
      label: 'Aucune capacité à supporter des pertes',
      suffix: { title: 'A' },
    },
    {
      value: 'LIMITED',
      label: 'Capacité limitée à supporter des pertes en capital',
      suffix: { title: 'B' },
    },
    {
      value: 'PARTIAL_LOSS',
      label: 'Perte partielle possible',
      suffix: { title: 'C' },
    },
    {
      value: 'TOTAL_LOSS',
      label: 'Perte totale possible',
      suffix: { title: 'D' },
    },
    {
      value: 'LOSS_BEYOND_CAPITAL',
      label: "Perte au-delà de l'investissement initial possible",
      suffix: { title: 'D' },
    },
  ];

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
